import React from 'react';
import PropTypes from 'prop-types';

export default function CustomFieldTitle(props) {

    const title = props.customField ? props.customField.name : 'New custom field';

    return (
        <div className="iv-header header-left header-small-no-separator">
            <div className="title-line">
                <div className="view-name">
                    <div className="ui5-title-app-name max-w-350 ">{title}</div>
                </div>
            </div>
        </div>
    );
}

CustomFieldTitle.propTypes = {
    customField: PropTypes.object
}